export default __webpack_public_path__ + "static/media/logo15.4b5e6d2d.jpg";